module.exports = __webpack_public_path__ + "static/media/alejandro_garnacho.d17a4e7f.jpg";